import type {
  SessionTodoForm,
  WysiwygContent,
} from "@/components/program-manager/sessions/components/TodosSection/types";
import type { TodoSubmission } from "./types";

export const isApplicationAssigned = (todo: TodoSubmission): boolean => !todo.session_todo_id && !todo.session_id;

export const todoSubmissionToForm = (todo: TodoSubmission): SessionTodoForm => ({
  todo_id: todo.todo_id,
  required: todo.required,
  placement: todo.placement,
  // Fall back to the same normal priority a new to-do starts on.
  ranking: todo.ranking ?? 2,
  display_name: todo.display_name ?? null,
  due_date: todo.due_date ?? null,
  instructions: todo.instructions as WysiwygContent,
  supporting_url: todo.supporting_url ?? null,
});
